import { RouteDetailViewModel } from './route-detail-viewmodel';

export class SelectedRouteViewModel {
    public routeId: string;
    public name: string;
    public daysCalculated: number;
    public totalDays: number;
    public startDate: Date;
    public endDate: Date;
    public startTime: Date;
    public endTime: Date;
    public interval: number;
    public selected: boolean;
    public color: string;

    constructor();
    constructor(routeDetail: RouteDetailViewModel, color: string, selected: boolean);
    constructor(routeDetail?: RouteDetailViewModel, color?: string, selected?: boolean) {
        if (routeDetail) {
            this.routeId = routeDetail.id;
            this.name = routeDetail.name;
            this.daysCalculated = routeDetail.daysCalculated;
            this.totalDays = routeDetail.totalDays;
            this.startDate = routeDetail.startDate;
            this.endDate = routeDetail.endDate;
            this.startTime = routeDetail.startTime;
            this.endTime = routeDetail.endTime;
            this.interval = routeDetail.interval;
            this.color = color;
            this.selected = selected;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/route-detail/viewModels/selectedRoute.viewmodel.ts